module.exports = __webpack_public_path__ + "static/media/permissionDrivers.5173a964.svg";